import React, { useState } from 'react';
import './SuccessStoriesPage.css';

const stories = [
  { id: 1, name: 'Rahim Abdullah', course: 'Computer Science', university: 'APU Malaysia', year: '2023', country: '🇧🇩', flag: '🇲🇾', quote: 'StudiLine made my dream of studying in Malaysia a reality. From visa to accommodation, everything was handled perfectly!', placeholder: 'RA', color: '#3b82f6' },
  { id: 2, name: 'Fatima Khanom', course: 'Business Administration', university: 'Taylor\'s University', year: '2023', country: '🇧🇩', flag: '🇲🇾', quote: 'I never thought studying abroad was possible for me. StudiLine showed me scholarships I didn\'t even know existed.', placeholder: 'FK', color: '#d4a843' },
  { id: 3, name: 'Karim Hossain', course: 'Medicine (MBBS)', university: 'IMU University', year: '2022', country: '🇧🇩', flag: '🇲🇾', quote: 'The counsellors guided me step by step. Getting into IMU for MBBS was my biggest achievement, and StudiLine was with me all the way.', placeholder: 'KH', color: '#2ec97e' },
  { id: 4, name: 'Nadia Islam', course: 'Hospitality Management', university: 'Berjaya University College', year: '2023', country: '🇧🇩', flag: '🇲🇾', quote: 'The team understood my goals and matched me with the perfect university. I am now thriving in KL!', placeholder: 'NI', color: '#f43f5e' },
  { id: 5, name: 'Tanvir Ahmed', course: 'Electrical Engineering', university: 'UNITEN', year: '2022', country: '🇧🇩', flag: '🇲🇾', quote: 'Professional, fast, and genuinely caring. They helped with everything — visa, housing, registration. Highly recommend!', placeholder: 'TA', color: '#8b5cf6' },
  { id: 6, name: 'Sadia Rahman', course: 'Pharmacy', university: 'MAHSA University', year: '2023', country: '🇧🇩', flag: '🇲🇾', quote: 'I was confused about which university to choose. The counsellors gave me detailed comparisons and helped me make the best decision.', placeholder: 'SR', color: '#06b6d4' },
  { id: 7, name: 'Rakib Islam', course: 'Architecture', university: 'Limkokwing University', year: '2022', country: '🇧🇩', flag: '🇲🇾', quote: 'StudiLine handled my entire application in 3 weeks. The process was smooth and stress-free. I am so grateful!', placeholder: 'RI', color: '#f97316' },
  { id: 8, name: 'Mitu Begum', course: 'Nursing', university: 'SEGi University', year: '2023', country: '🇧🇩', flag: '🇲🇾', quote: 'As a girl studying abroad for the first time, I was nervous. But StudiLine\'s team made sure I felt safe and supported throughout.', placeholder: 'MB', color: '#ec4899' },
  { id: 9, name: 'Zahid Hassan', course: 'MBA', university: 'Sunway University', year: '2023', country: '🇧🇩', flag: '🇲🇾', quote: 'Got my student visa in record time. The team was responsive and I never had to chase them for updates. Excellent service!', placeholder: 'ZH', color: '#14b8a6' },
];

export default function SuccessStoriesPage() {
  const [selected, setSelected] = useState(null);

  return (
    <div className="ss-page">
      <div className="ss-hero">
        <div className="ss-hero-inner">
          <span className="section-tag">Real Students, Real Results</span>
          <h1 className="ss-title">Success <span className="gold-text">Stories</span></h1>
          <p className="ss-sub">
            Hundreds of students have trusted StudiLine to guide their journey to Malaysian universities.
            Here are some of their inspiring stories.
          </p>
        </div>
      </div>

      <div className="ss-body">
        <div className="ss-grid">
          {stories.map((s, i) => (
            <div
              key={s.id}
              className={`ss-card ${selected === i ? 'expanded' : ''}`}
              style={{ animationDelay: `${i * 0.05}s`, '--accent': s.color }}
              onClick={() => setSelected(selected === i ? null : i)}
            >
              <div className="ss-card-header">
                <div className="ss-avatar" style={{ background: s.color + '22', border: `2px solid ${s.color}55` }}>
                  <span style={{ color: s.color, fontWeight: 800, fontSize: '18px' }}>{s.placeholder}</span>
                </div>
                <div className="ss-info">
                  <h3 className="ss-name">{s.name}</h3>
                  <div className="ss-meta">
                    <span>{s.country} → {s.flag}</span>
                    <span className="ss-dot">·</span>
                    <span>{s.year}</span>
                  </div>
                </div>
                <div className="ss-expand-icon">{selected === i ? '▲' : '▼'}</div>
              </div>

              <div className="ss-uni-row">
                <span className="ss-course-pill">{s.course}</span>
                <span className="ss-uni-name">@ {s.university}</span>
              </div>

              <div className="ss-quote-wrap">
                <span className="ss-quote-mark">"</span>
                <p className="ss-quote">{s.quote}</p>
              </div>

              <div className="ss-footer-row">
                <div className="ss-stars">★★★★★</div>
                <span className="ss-read">
                  {selected === i ? 'Close' : 'Read More'}
                </span>
              </div>

              {selected === i && (
                <div className="ss-expanded-content">
                  <div className="ss-detail-grid">
                    <div className="ss-detail-item"><span className="sd-label">University</span><span className="sd-value">{s.university}</span></div>
                    <div className="ss-detail-item"><span className="sd-label">Course</span><span className="sd-value">{s.course}</span></div>
                    <div className="ss-detail-item"><span className="sd-label">Year Enrolled</span><span className="sd-value">{s.year}</span></div>
                    <div className="ss-detail-item"><span className="sd-label">Rating</span><span className="sd-value">★★★★★ 5/5</span></div>
                  </div>
                  <a
                    href={`https://wa.me/601169479883?text=I saw ${s.name}'s story and want to know more about studying in Malaysia`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ss-wa-btn"
                    onClick={e => e.stopPropagation()}
                  >
                    💬 Get Similar Results — Chat with Us
                  </a>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="ss-upload-section">
          <div className="ss-upload-inner">
            <div className="ss-upload-icon">📸</div>
            <h2>Share Your Success Story</h2>
            <p>Are you a StudiLine student? We'd love to feature your journey!</p>
            <a href="mailto:studiline.bd@gmail.com?subject=My Success Story" className="ss-share-btn">
              📧 Send Your Story
            </a>
            <a href="https://wa.me/601169479883?text=I want to share my success story!" target="_blank" rel="noopener noreferrer" className="ss-wa-share-btn">
              💬 WhatsApp Us
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
